import { createReducer, on } from '@ngrx/store';
import { instructorActions } from '../actions/instructor.actions';
import { Instructor } from '../models';

export interface InstructorState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    instructor: Instructor | null;
}

export const initialState: InstructorState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    instructor: null,
};

export const instructorReducer = createReducer(
    initialState,
    // Get
    on(
        instructorActions.getInstructor,
        (state): InstructorState => ({
            ...state,
            loading: true,
            loaded: null,
            error: null,
        }),
    ),
    on(
        instructorActions.getInstructorSuccess,
        (state, { payload }): InstructorState => ({
            ...state,
            loading: false,
            loaded: true,
            error: null,
            instructor: payload,
        }),
    ),
    on(
        instructorActions.getInstructorError,
        (state, payload): InstructorState => ({
            ...state,
            loading: false,
            loaded: false,
            error: payload.code,
        }),
    ),
    // Create
    on(
        instructorActions.createInstructor,
        (state): InstructorState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        instructorActions.createInstructorSuccess,
        (state, { payload }): InstructorState => ({
            ...state,
            saving: false,
            saved: true,
            instructor: payload,
        }),
    ),
    on(
        instructorActions.createInstructorError,
        (state): InstructorState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Update
    on(
        instructorActions.updateInstructor,
        (state): InstructorState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        instructorActions.updateInstructorSuccess,
        (state, { payload }): InstructorState => ({
            ...state,
            saving: false,
            saved: true,
            instructor: payload,
        }),
    ),
    on(
        instructorActions.updateInstructorError,
        (state): InstructorState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Delete
    on(
        instructorActions.deleteInstructor,
        (state): InstructorState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        instructorActions.deleteInstructorSuccess,
        (state): InstructorState => ({
            ...state,
            saving: false,
            saved: true,
            instructor: null,
        }),
    ),
    on(
        instructorActions.deleteInstructorError,
        (state): InstructorState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Clear
    on(instructorActions.clear, (): InstructorState => ({ ...initialState })),
);
